import Token from "./hardhat/artifacts/contracts/Lottery.sol/IERC20.json"
import Dividend from "./hardhat/artifacts/contracts/Dividend.sol/Dividend.json"
import { ethers } from 'ethers';
import Decimal from "decimal.js"

import { Button, Input, message } from 'antd';
import { IntlProvider, FormattedMessage } from 'react-intl';
import messages from './lang/index';
import { useState } from 'react';



let BTokenAddr = "0xaA4cfc66fef889CAF3ddB770b0A3bbB4fABA6415";//0xC7e6D9838C4c5D3A4147546a6536dEe175F73bE9
let DividendAddr = "0x83675DF82d239aB58cD8b2DF8e7d54006c537824";

let BTokenContractdecimals;

let Provider;
let BTokenContract;
let DividendContract;
let account;
let RefAddr;
let chainInfo;
let connWallet;
let owner;
let Mainnet;

let burninputreadOnly;

function App() {
  const [locale, setLocale] = useState(localStorage.getItem('locale') || 'zh');
  const [Account, setAccount] = useState();


  const [BurnRecommendAddr, setBurnRecommendAddr] = useState(locale === 'zh' ? '请输入销毁推荐人地址' : 'Please enter the burn recommender');
  const [DefaultInputBurnValue, setDefaultInputBurnValue] = useState(locale === 'zh' ? '请输入销毁数量' : 'Please input the burn value');

  const [MyTokenBBalance, setMyTokenBBalance] = useState("--");
  const [TokenBName, setTokenBName] = useState("--");
  const [BurnSum, setBurnSum] = useState("--");
  const [MyBurnSum, setMyBurnSum] = useState("--");
  const [MyBurnProportion, setMyBurnProportion] = useState("--");
  const [RefBurnProportion, setRefBurnProportion] = useState("--")
  const [MyRefBurnReward, setMyRefBurnReward] = useState("--")
  const [TemporaryBurnAmount, setTemporaryBurnAmount] = useState("--")
  const [TemporaryrefRewardP, setTemporaryrefRewardP] = useState("--")
  const [GetReward, setGetReward] = useState("--")

  const [ConnectWalletLoading, setConnectWalletLoading] = useState(false)
  const [Bind_BurnRecommenderLoading, setBind_BrunRecommenderLoading] = useState(false)
  const [BurnButtonStatus, setBurnButtonStatus] = useState(false)
  const [GetRewardLoading, setGetRewardLoading] = useState(false)
  const [DistributeDividendsloading, setDistributeDividendsloading] = useState(false)

  const [BurnInuptRefData, setBurnInuptRefData] = useState()
  const [InputBurn, setInputBurn] = useState()
  const [_r4, set_r4] = useState()

  function isMetaMaskInstalled() {
    //Have to check the ethereum binding on the window object to see if it's installed
    const { ethereum } = window;
    return Boolean(ethereum && ethereum.isMetaMask);
  }

  let ConnectWallet = async () => {
    try {
      if (isMetaMaskInstalled()) {
        if (connWallet) {
          return
        }
        setConnectWalletLoading(true);
        await GetAccount();
        Provider = new ethers.providers.Web3Provider(window.ethereum);
        BTokenContract = new ethers.Contract(BTokenAddr, Token.abi, Provider.getSigner());
        DividendContract = new ethers.Contract(DividendAddr, Dividend.abi, Provider.getSigner());

        owner = await DividendContract.owner();
        BTokenContractdecimals = await BTokenContract.decimals();
        let BTokenContractsymbol = await BTokenContract.symbol();
        setTokenBName(BTokenContractsymbol);
        await chainChanged();
        await GetGameInfo();
        setConnectWalletLoading(false);
        Provider.on('block', async (blockNumber) => {
          //console.log("blockNumber:", blockNumber)
          await GetGameInfo();
        });
        window.ethereum.on('chainChanged', async function () {
          if (connWallet) {
            connWallet = false;
            await ConnectWallet()
            await GetAccount();
          }

        })
        window.ethereum.on('accountsChanged', async function () {
          //if (connWallet) {
          connWallet = false;
          await ConnectWallet()
          await GetAccount();
          //}
        })
      }

    } catch (err) {
      setConnectWalletLoading(false);
      console.log(err)
    }

  }

  let GetAccount = async () => {
    try {
      await window.ethereum.request({ method: 'eth_requestAccounts' })
        .then((accounts) => {
          account = accounts[0];
        }).catch((error) => {
          console.error(error)
        });
    } catch (err) {
      console.log(err)
    }

  }

  let chainChanged = async () => {
    try {
      Provider = new ethers.providers.Web3Provider(window.ethereum);
      chainInfo = await Provider.getNetwork();
      if (Mainnet) {
        if (chainInfo.chainId !== 131419) {
          setAccount("Please switch to the ETND main network");
          await window.ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: '0x2015b' }],
          });
        } else {
          setAccount(account.substring(0, 10) + '...' + account.substring(33, 42).toString());
        }
      } else {
        //if (chainInfo.chainId !== 31337) {
        if (chainInfo.chainId !== 131419) {
          setAccount("Please switch to the ETND network");
          await window.ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: '0x2015b' }],
          });
        } else {
          setAccount(account.substring(0, 10) + '...' + account.substring(33, 42).toString());
        }
      }
    } catch (err) {
      Provider = new ethers.providers.Web3Provider(window.ethereum);
      chainInfo = await Provider.getNetwork();

      if (Mainnet) {
        if (chainInfo.chainId !== 131419) {
          setAccount("Please switch to the ETND main network");
          await window.ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: '0x2015b' }],
          });
        } else {
          setAccount(account.substring(0, 10) + '...' + account.substring(33, 42).toString());
        }
      } else {
        //if (chainInfo.chainId !== 31337) {
        if (chainInfo.chainId !== 131419) {
          setAccount("Please switch to the ETND network");
          await window.ethereum.request({
            method: 'wallet_switchEthereumChain',
            params: [{ chainId: '0x2015b' }],
          });
        } else {
          setAccount(account.substring(0, 10) + '...' + account.substring(33, 42).toString());
        }
      }
      console.log(err)
    }
    connWallet = true;
  }

  let ConnectWalletButton = () => {
    try {
      if (Account) {
        return Account;
      } else {
        return (<FormattedMessage id="link" />);
      }
    } catch (err) {
      console.log(err)
    }
  }

  let GetGameInfo = async () => {
    try {
      await GetAllBalance();
      await GetBurnRecommendAddr();
    } catch (err) {
      console.log(err)
    }
  }



  let GetAllBalance = async () => {
    try {
      let _MyTokenBBalance = await BTokenContract.balanceOf(account);
      if (_MyTokenBBalance == 0) {
        setMyTokenBBalance("0")
      } else {
        setMyTokenBBalance((new Decimal(_MyTokenBBalance.toString()).div(new Decimal(10).pow(BTokenContractdecimals.toString()))).toFixed(6));
      }


      let _MyBurnSum = await DividendContract.burnAmount(account);
      if (_MyBurnSum == 0) {
        setMyBurnSum("0")
      } else {
        setMyBurnSum((new Decimal(_MyBurnSum.toString()).div(new Decimal(10).pow(BTokenContractdecimals.toString()))).toFixed(6));

      }
      let _BurnSum = await DividendContract.burnSum();
      setBurnSum((new Decimal(_BurnSum.toString()).div(new Decimal(10).pow(BTokenContractdecimals.toString()))).toFixed(6));
      if (_MyBurnSum == 0) {
        setMyBurnProportion("0%");
      } else {
        let _MyBurnProportion = (new Decimal(_MyBurnSum.toString()).div(new Decimal(_BurnSum.toString())).mul(new Decimal(100).toString())).toFixed(2)
        setMyBurnProportion(_MyBurnProportion + "%");
      }

      let _RefburnSum = await DividendContract.RefburnSum();
      //console.log(_RefburnSum)

      if (_RefburnSum == 0) {
        setRefBurnProportion("0")
      } else {
        setRefBurnProportion((new Decimal(_RefburnSum.toString()).div(new Decimal(_BurnSum.toString())).mul(new Decimal(100))).toFixed(2));
      }
      let _temporaryRefBurnSum = await DividendContract.refRewardP(account)
      if (_temporaryRefBurnSum == 0) {
        setMyRefBurnReward("0")
      } else {
        setMyRefBurnReward((new Decimal(_temporaryRefBurnSum.toString()).div(new Decimal(10).pow(BTokenContractdecimals.toString()))).toFixed(6))
      }
      let _round = await DividendContract.round();

      let _temporaryBurnAmount = await DividendContract.temporaryBurnAmount(account, _round.toString())
      //console.log("_temporaryBurnAmount",_temporaryBurnAmount)
      if (_temporaryBurnAmount == 0) {
        setTemporaryBurnAmount("0")
      } else {
        setTemporaryBurnAmount((new Decimal(_temporaryBurnAmount.toString()).div(new Decimal(10).pow(BTokenContractdecimals.toString()))).toFixed(6))
      }

      let _temporaryrefRewardP = await DividendContract.temporaryrefRewardP(account, _round.toString())
      if (_temporaryrefRewardP == 0) {
        setTemporaryrefRewardP("0")
      } else {
        setTemporaryrefRewardP((new Decimal(_temporaryrefRewardP.toString()).div(new Decimal(10).pow(BTokenContractdecimals.toString()))).toFixed(6))
      }

      let _getReward = await DividendContract.getReward()
      if (_getReward == 0) {
        setGetReward("0")
      } else {
        setGetReward(new Decimal(ethers.utils.formatUnits(_getReward.toString(), 18)).toFixed(6))
      }

    } catch (err) {
      console.log(err)
    }
  }

  let GetBurnRecommendAddr = async () => {
    try {
      //let _RefAddr = "0x0000000000000000000000000000000000000000"
      let _RefAddr = await DividendContract.Ref(account);
      RefAddr = _RefAddr;
      if (_RefAddr.toString() != "0x0000000000000000000000000000000000000000") {
        setBurnRecommendAddr(_RefAddr.toString());
        burninputreadOnly = true;
      } else {
        burninputreadOnly = false;
      }
    } catch (err) {
      console.log(err)
    }
  }

  let Bind_BurnRecommenderButton = async (_ref) => {
    try {
      if (!connWallet) {
        if (locale === 'zh') {
          message.warning("请先连接钱包", 0.7);
          return
        }
        message.warning("Please connect your wallet first", 0.7);
        return
      }
      if (burninputreadOnly) {
        return
      }
      //console.log(_ref1)
      if (!_ref) {
        if (locale === 'zh') {
          message.warning("推荐地址不能为空", 0.7);
          return
        }
        message.warning("Please enter the address of the recommender", 0.7);
        return
      }
      let _ref1 = _ref.toString().replace(/\s*/g, "");
      console.log(_ref1.toString(), ethers.utils.isAddress(_ref1))
      if (!ethers.utils.isAddress(_ref1)) {
        if (locale === 'zh') {
          message.warning("地址格式错误", 0.7);
          return
        }
        message.warning("Address format error", 0.7);
        return
      }
      console.log(_ref1)

      setBind_BrunRecommenderLoading(true);
      let _tx = await DividendContract.BindRef(_ref1);

      await _tx.wait();
      await GetBurnRecommendAddr();
      setBind_BrunRecommenderLoading(false);
    } catch (err) {
      setBind_BrunRecommenderLoading(false);
      if (locale === 'zh') {
        message.warning("推荐人地址未注册", 1);
      } else {
        message.warning("The address of the recommender is not registered", 1);
      }
      console.log(err)
    }
  }


  let Max_burnValue = async () => {
    try {
      if (!connWallet) {
        if (locale === 'zh') {
          message.warning("请先连接钱包", 0.7);
          return
        }
        message.warning("Please connect your wallet first", 0.7);
        return
      }
      setInputBurn(MyTokenBBalance)
      //setBurnValue(MyTokenBBalance)

    } catch (err) {
      console.log(err)
    }
  }


  let Burn = async (_value) => {
    try {
      if (!connWallet) {
        if (locale === 'zh') {
          message.warning("请先连接钱包", 0.7);
          return
        }
        message.warning("Please connect your wallet first", 0.7);
        return
      }
      if (!_value) {
        return
      }
      let _MyTokenBBalance = await BTokenContract.balanceOf(account);
      setBurnButtonStatus(true);

      let _value_ = ethers.utils.parseUnits(_value.toString(), BTokenContractdecimals.toString());

      console.log("ref", RefAddr.toString())
      if (RefAddr.toString() == "0x0000000000000000000000000000000000000000") {
        if (locale === 'zh') {
          message.warning("请先绑定推荐人", 1);
          setBurnButtonStatus(false);
          return
        }
        message.warning("Please bind the recommender first", 1);
        setBurnButtonStatus(false);
        return
      }
      console.log(_MyTokenBBalance.toString(), _value_.toString())
      if (new Decimal(_value_.toString()).greaterThan(new Decimal(_MyTokenBBalance.toString()))) {
        if (locale === 'zh') {
          message.warning("额度不足", 0.7);
          setBurnButtonStatus(false);
          return
        }
        message.warning("Sorry, your credit is running low", 0.7);
        setBurnButtonStatus(false);
        return
      }

      let tx = await BTokenContract.approve(DividendAddr, _value_);
      await tx.wait();

      let _tx = await DividendContract.Burn(_value_);
      await _tx.wait();
      // await GetBurnRecommendAddr();
      setBurnButtonStatus(false);
      setBurnInuptRefData()
    } catch (err) {
      setBurnButtonStatus(false);
      console.log(err)
    }
  }

  let GetRewards = async () => {
    try {
      if (!connWallet) {
        if (locale === 'zh') {
          message.warning("请先连接钱包", 0.7);
          return
        }
        message.warning("Please connect your wallet first", 0.7);
        return
      }
      setGetRewardLoading(true)
      let tx = await DividendContract.GetReward();
      await tx.wait()
      setGetRewardLoading(false)
    } catch (err) {
      setGetRewardLoading(false)
      console.log(err)
    }
  }

  

  let DistributeDividends = async () => {
    try {
      if (!connWallet) {
        if (locale === 'zh') {
          message.warning("请先连接钱包", 0.7);
          return
        }
        message.warning("Please connect your wallet first", 0.7);
        return
      }
      setDistributeDividendsloading(true)
      let _r4s = _r4.toString()
      console.log(_r4s)
      const options = {value: ethers.utils.parseEther(_r4s)}
      let tx = await DividendContract.DividendENT(options);
      await tx.wait()
      setDistributeDividendsloading(false)
    } catch (err) {
      setDistributeDividendsloading(false)
      console.log(err)
    }
  }

  // 切换语言
  const onToggleLocale = () => {
    let _locale = locale === 'zh' ? 'en' : 'zh';
    localStorage.setItem('locale', _locale);
    setLocale(_locale);
  }


  return (
    <IntlProvider key={locale} locale={locale} messages={messages[locale]}>
      <div className="max-width-500 w-100 h-100 px-3 text-md color-white overflow-auto slim-no-scroll pt-3 pb-5">
        <header className="d-flex align-items-center justify-content-between mb-3 color-purple-5">
          <Button className="ant-btn-purple" onClick={ConnectWallet} loading={ConnectWalletLoading}>
            <ConnectWalletButton />
          </Button>
          <div onClick={onToggleLocale} className="flex-center-center">
            <svg t="1660977407777" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="3411" width="1.4rem" height="1.4rem"><path d="M512.9 960.2c-245.5 0-445.3-199.8-445.3-445.3S267.4 69.6 512.9 69.6c97.2 0 189.6 30.8 267.1 89 15.1 11.4 18.2 32.8 6.8 48-11.4 15.1-32.8 18.2-48 6.8-65.6-49.2-143.7-75.2-226-75.2C305 138.2 136 307.2 136 515s169 376.8 376.8 376.8 376.8-169 376.8-376.8c0-48.5-9.1-95.8-27-140.4-7.1-17.6 1.5-37.5 19-44.6 17.6-7.1 37.5 1.5 44.6 19 21.2 52.8 32 108.6 32 165.9 0 245.6-199.7 445.3-445.3 445.3z" fill="#d5c7fc" p-id="3412"></path><path d="M829.1 273.3m-39.5 0a39.5 39.5 0 1 0 79 0 39.5 39.5 0 1 0-79 0Z" fill="#d5c7fc" p-id="3413"></path><path d="M523.6 954.4c-6.3 0-12.6-2.2-17.8-6.6-16.1-13.7-31.6-28.6-46.1-44.3-45.5-48.9-81.4-104.9-106.8-166.5-27.4-66.3-41.4-136.5-41.9-208.8v-3.5c0-61.6 10.1-122.2 29.8-180 28.8-84.1 78.2-161.2 143-222.8 4.9-4.7 10-9.3 15.1-13.8 11.3-10 28.7-9 38.7 2.4 10 11.3 9 28.7-2.4 38.7-4.6 4.1-9.2 8.3-13.6 12.5-58.3 55.6-102.9 125-128.9 200.8-17.8 52.1-26.9 106.7-26.9 162.3v3.3c0.4 65 13.1 128.3 37.7 188 22.9 55.5 55.3 106 96.3 150.1 13.1 14.2 27.1 27.6 41.5 39.9 11.5 9.8 12.9 27.1 3 38.6-5.2 6.4-12.9 9.7-20.7 9.7z" fill="#d5c7fc" p-id="3414"></path><path d="M487.4 953.1c-8.4 0-16.6-3.8-22-11-9.1-12.1-6.6-29.3 5.6-38.4 16-11.9 31.4-25 45.9-38.7 43.8-41.7 79.3-90.2 105.5-144.3 29.6-60.8 46.3-126.1 49.6-193.9 0.4-8.5 0.6-16.9 0.6-25 0-43.4-5.5-86.6-16.5-128.1-20.8-79.2-61.5-153-117.5-213.3-4-4.4-8.3-8.8-13.2-13.7-10.7-10.7-10.8-28-0.1-38.8 10.7-10.7 28-10.8 38.8-0.1 5.6 5.5 10.4 10.6 14.9 15.5 62 66.7 107.1 148.5 130.2 236.5 12.1 46.1 18.3 93.9 18.3 142.1 0 9-0.2 18.3-0.7 27.6-3.7 75.3-22.2 147.7-55.1 215.2-29.1 60-68.5 113.8-117 160-16 15.3-33.1 29.7-50.9 42.9-5 3.7-10.7 5.5-16.4 5.5z" fill="#d5c7fc" p-id="3415"></path><path d="M834.9 747.1c-5.3 0-10.7-1.5-15.4-4.8-58.1-39.7-122.1-67.9-190.2-83.9-42.6-10-86.6-15.1-130.8-15.1h-0.2c-33.2 0-66.3 2.8-98.6 8.5-73 12.7-142 39.3-204.9 78.9-12.8 8.1-29.7 4.2-37.8-8.6-8.1-12.8-4.2-29.7 8.6-37.8 69-43.4 144.6-72.5 224.7-86.5 35.4-6.2 71.7-9.3 108-9.3h0.2c48.4 0 96.6 5.6 143.3 16.6 74.7 17.5 144.9 48.5 208.6 92 12.5 8.5 15.7 25.6 7.2 38.1-5.4 7.7-14 11.9-22.7 11.9zM924 480.5l-801.8-0.3c-15.1 0-27.4-12.3-27.4-27.4 0-15.1 12.3-27.4 27.4-27.4l801.8 0.3c15.1 0 27.4 12.3 27.4 27.4 0 15.2-12.3 27.4-27.4 27.4z" fill="#d5c7fc" p-id="3416"></path></svg>
            <div className="ml-1">{locale.toUpperCase()}</div>
          </div>
        </header>

        <section className="flex-item text-sm mt-3 bg-dark-5 round-md">
          <div className="flex-content flex-vertical align-items-center justify-content-center px-3 py-2">
            <div className="flex-item align-items-center mt-2">
              <div>
                <FormattedMessage id="NetworkWideInformation" />:
              </div>

            </div>
            <div className="flex-item align-items-center mt-4">
              <div>
                <FormattedMessage id="burnSum" />:
              </div>
              <div className="color-light ml-2 text-md">{BurnSum}</div>
            </div>
            <div className="flex-item align-items-center mt-4">
              <div>
                <FormattedMessage id="NetworkRefBurn" />:
              </div>
              <div className="color-light ml-2 text-md">{RefBurnProportion}%</div>
            </div>


          </div>
        </section>

        <section className="flex-item text-sm mt-3 bg-dark-5 round-md">
          <div className="flex-content flex-vertical align-items-center justify-content-center px-3 py-2">
            <div className="flex-item align-items-center mt-2">
              <div>
                <FormattedMessage id="PlayerInformation" />:
              </div>
            </div>
            <div className="flex-item align-items-center mt-4">
              <div>
                <FormattedMessage id="burnProportion" />:
              </div>
              <div className="color-light ml-2 text-md">{MyBurnProportion}</div>
            </div>

            <div className="flex-item align-items-center mt-2">
              <div>
                <FormattedMessage id="burnValue" />:
              </div>
              <div className="color-light ml-2 text-md">{MyBurnSum}</div>
            </div>
            <div className="flex-item align-items-center mt-2">
              <div>
                <FormattedMessage id="RefBurnProportion" />:
              </div>
              <div className="color-light ml-2 text-md">{MyRefBurnReward}</div>
            </div>
            <div className="flex-item align-items-center mt-2">
              <div>
                {TokenBName}<FormattedMessage id="balance" />:
              </div>
              <div className="color-light ml-2 text-md">{MyTokenBBalance}</div>
            </div>
          </div>
        </section>
        <div className="flex-item align-items-center mt-5">

          <Input className="flex-content input-background" value={InputBurn} placeholder={DefaultInputBurnValue} onChange={(event) => {
            setInputBurn(event.target.value)
          }} />
          <Button className="flex-label ant-btn-warning" onClick={async () => {
            await Max_burnValue()
          }}>
            <FormattedMessage id="max" />
          </Button>


          <Button className="flex-label ant-btn-warning" loading={BurnButtonStatus} onClick={async () => {
            await Burn(InputBurn)
          }}>
            <FormattedMessage id="burn" />
          </Button>
        </div>

        <section className="flex-item text-sm mt-3 bg-dark-5 round-md">
          <div className="flex-content flex-vertical align-items-center justify-content-center px-3 py-2">
            <div className="flex-item align-items-center mt-2">
              <div>
                <FormattedMessage id="ReceiveAnAward" />:
              </div>
            </div>


            <div className="flex-item align-items-center mt-4">
              <div>
                <FormattedMessage id="_r" />:
              </div>
              <div className="color-light ml-2 text-md">{TemporaryrefRewardP}</div>
            </div>

            <div className="flex-item align-items-center mt-4">
              <div>
                <FormattedMessage id="_r1" />:
              </div>
              <div className="color-light ml-2 text-md">{TemporaryBurnAmount}</div>
            </div>

            <div className="flex-item align-items-center mt-4">
              <div>
                <FormattedMessage id="_r2" />:
              </div>
              <div className="color-light ml-2 text-md">{GetReward}</div>
            </div>
            <section className="mt-5 flex-item input-box position-relative">

            </section>
            <Button className="flex-label ant-btn-warning" loading={GetRewardLoading} onClick={async () => {
              await GetRewards()
            }}>
              <FormattedMessage id="_r3" />
            </Button>
          </div>
        </section>


        <section className="mt-5 flex-item input-box position-relative">
          <Input className="flex-content" placeholder={BurnRecommendAddr} readOnly={burninputreadOnly} onChange={(event) => {
            setBurnInuptRefData(event.target.value)
          }} />
          <Button className="flex-label ant-btn-warning" loading={Bind_BurnRecommenderLoading} onClick={async () => {
            await Bind_BurnRecommenderButton(BurnInuptRefData)
          }}>
            <FormattedMessage id="bind" />
          </Button>
        </section>
        {/* <OwnerButton></OwnerButton> */}

        
        <section className="mt-5 flex-item  position-relative">
        <Input className="flex-content"   onChange={(event) => {
            set_r4(event.target.value)
          }} />
          <Button className="flex-label ant-btn-warning" loading={DistributeDividendsloading} onClick={async () => {
            await DistributeDividends()
          }}>
            <FormattedMessage id="_r4" />
            
          </Button>
        </section>
      </div>
    </IntlProvider>
  );
}

export default App;
